import type { AddressData } from '../types'

const normalizeWhitespace = (value: string): string => value.trim().replace(/\s+/g, ' ')

/**
 * Normalize an address field for comparisons.
 * Uses trim + collapse whitespace + lowercase, with special handling for postal code.
 */
export const normalizeAddressValue = (key: keyof AddressData, value: string): string => {
  const normalized = normalizeWhitespace(value).toLowerCase()
  if (normalized === '') return ''

  // Allow "123 45" and "12345" to match for postal code.
  if (key === 'postalCode') return normalized.replace(/\s+/g, '')

  return normalized
}

/**
 * Check if all provided keys are empty (after normalization).
 */
export const isEmptyAddress = (address: AddressData, keys: Array<keyof AddressData>): boolean =>
  keys.every((key) => normalizeAddressValue(key, address[key]) === '')

/**
 * Compare two addresses across the provided keys (after normalization).
 */
export const isSameAddress = (
  a: AddressData,
  b: AddressData,
  keys: Array<keyof AddressData>,
): boolean =>
  keys.every((key) => normalizeAddressValue(key, a[key]) === normalizeAddressValue(key, b[key]))
